var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInputEyeClose = function SvgInputEyeClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.244 5.41C5.428 4.69 6.887 4.097 8.5 4.097s3.072.594 4.256 1.315c1.19.725 2.164 1.615 2.818 2.293l.054.056c.394.407.718.742.718 1.24s-.324.833-.718 1.24l-.054.056c-.654.678-1.627 1.568-2.818 2.293-1.184.721-2.643 1.315-4.256 1.315s-3.072-.594-4.256-1.315c-1.19-.725-2.164-1.616-2.818-2.293l-.054-.056C.978 9.833.654 9.498.654 9s.324-.833.718-1.24l.054-.056c.654-.678 1.627-1.568 2.818-2.293",
    clipRule: "evenodd"
  })));
};
export { SvgInputEyeClose as ReactComponent };